import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Popup } from 'components';

import AssociateAccount from '../AssociateAccount';
import AssociateAccountSuccess from '../AssociateAccountSuccess';
import AssociateAccountInProgress from '../AssociateAccountInProgress';

const getDefaultState = (props) => ({
  isPasswordAvailable: props.withPassword,
  userLogin: '',
  userPassword: '',
  userType: null,
});

class AssociateAccountPopup extends PureComponent {
  constructor(props) {
    super(props);

    this.state = getDefaultState(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.isOpened && props.userTypes !== this.props.userTypes) {
      this.setState({
        userType: props.userTypes ? props.userTypes[0] : null,
      });
    }
  }

  changeUserType = (userType) => {
    this.setState({
      userType,
    });
  };

  togglePasswordAvailability = () => {
    this.setState((prevState) => ({
      isPasswordAvailable: !prevState.isPasswordAvailable,
    }));
  };

  changeUserLogin = (value) => {
    this.setState({
      userLogin: value,
    });
  };

  changeUserPassword = (value) => {
    this.setState({
      userPassword: value,
    });
  };

  closePopup = () => {
    this.refreshState(this.props.onClose);
  };

  refreshState(callback) {
    if (!this.props.accountLinkingStatus.isUpdating
        && !this.props.isAccountLinkCanceling) {
      this.setState(getDefaultState(this.props), callback);
    }
  }

  renderPopupBody() {
    const {
      onCreateLink,
      accountLinkingStatus,
      withPassword,
      isAccountLinkCanceling,
      showOffer,
      userTypes,
    } = this.props;

    const {
      isPasswordAvailable,
      userLogin,
      userPassword,
      userType,
    } = this.state;

    if (accountLinkingStatus.isSent) {
      return (
        <AssociateAccountInProgress
          login={userLogin}
          onClose={this.closePopup}
          isAccountLinkCanceling={isAccountLinkCanceling}
        />
      );
    }

    if (accountLinkingStatus.success) {
      return (
        <AssociateAccountSuccess
          login={userLogin}
          onClose={this.closePopup}
        />
      );
    }

    return (
      <AssociateAccount
        onCreateLink={onCreateLink}
        accountLinkingStatus={accountLinkingStatus}
        withPassword={withPassword}
        isPasswordAvailable={isPasswordAvailable}
        userLogin={userLogin}
        userPassword={userPassword}
        togglePasswordAvailability={this.togglePasswordAvailability}
        changeUserLogin={this.changeUserLogin}
        changeUserPassword={this.changeUserPassword}
        showOffer={showOffer}
        userTypes={userTypes}
        userType={userType}
        changeUserType={this.changeUserType}
      />
    );
  }

  render() {
    return (
      <Popup
        opened={this.props.isOpened}
        onClose={this.closePopup}
      >
        {this.renderPopupBody()}
      </Popup>
    );
  }
}

AssociateAccountPopup.defaultProps = {
  withPassword: false,
};

AssociateAccountPopup.propTypes = {
  isOpened: PropTypes.bool,
  userTypes: PropTypes.array,
  onClose: PropTypes.func,
  onCreateLink: PropTypes.func,
  accountLinkingStatus: PropTypes.object,
  withPassword: PropTypes.bool,
  isAccountLinkCanceling: PropTypes.bool,
  showOffer: PropTypes.func,
};

export default AssociateAccountPopup;
